/* Target two column blocks to reduce spacing if they are adjacent */
$(function () {
    var $parents = $('.flexibleblocks-block');

    // Only target those with a matching color class
    var $adjacentBlocks = $parents.filter(':has(>.two-column-block.__dark) + .flexibleblocks-block:has(.two-column-block.__dark), :has(>.two-column-block.__light) + .flexibleblocks-block:has(.two-column-block.__light)');

    $adjacentBlocks.addClass('adjacentBlocks');
});

